// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinMunichGarage_container__3V2Ry","rules":"JoinMunichGarage_rules__3l7FL","logo":"JoinMunichGarage_logo__1AGQt"};